module.exports = __webpack_public_path__ + "img/HeaderSecciones3.8f5f6754.png";